/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Campaignservicev1Creative } from '../models/Campaignservicev1Creative';
import { Campaignservicev1OrderLine } from '../models/Campaignservicev1OrderLine';
import { HttpFile } from '../http/http';

/**
* The event emitted when Creative is Added to an order line
*/
export class V1CreativeAdded {
    'orderLineId'?: string;
    'creative'?: Campaignservicev1Creative;
    'userId'?: string;
    'orgId'?: string;
    'timestamp'?: Date;
    'requestId'?: string;
    'orderLinePreUpdate'?: Campaignservicev1OrderLine;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orderLineId",
            "baseName": "order_line_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "creative",
            "baseName": "creative",
            "type": "Campaignservicev1Creative",
            "format": ""
        },
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "requestId",
            "baseName": "request_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orderLinePreUpdate",
            "baseName": "order_line_pre_update",
            "type": "Campaignservicev1OrderLine",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1CreativeAdded.attributeTypeMap;
    }

    public constructor() {
    }
}

